import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ActionResultModel } from 'src/app/models/common/ActionResultModel';
import { SearchResultModel } from 'src/app/models/common/SearchResultModel';
import { ICompaniaModel } from 'src/app/models/interfaces/compania/ICompaniaModel';
import { IFilterCompaniaModel } from 'src/app/models/interfaces/compania/IFilterCompaniaModel';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CompaniaService {
  private configUrl = [environment.apiGatewayUrl, 'companias'].join('/');
  constructor(private http: HttpClient,
    private datepipe: DatePipe) { }

    getListFiltered(
      model: IFilterCompaniaModel
      ) : Observable<SearchResultModel<ICompaniaModel[]>> {
      let queryParams: string[] = new Array<string>();
  
      queryParams.push(`page=${model.page}`);
      queryParams.push(`take=${model.pageSize}`);
      queryParams.push(`nombre=${model.nombre}`);
      
      if (model.compania !== '') {
        queryParams.push(`ids=${model.compania}`);
      }
  
      return this.http.get<SearchResultModel<ICompaniaModel[]>>(
        `${this.configUrl}/filtrar?${queryParams.join('&')}`
      );
    }
  
  
    getAllList(
      model: IFilterCompaniaModel
      ) : Observable<ICompaniaModel[]> {
      let queryParams: string[] = new Array<string>();
  
      queryParams.push(`nombre=${model.nombre}`);
      if (model.compania !== '') {
        queryParams.push(`ids=${model.compania}`);
      }
  
      return this.http.get<ICompaniaModel[]>(
        `${this.configUrl}/all?${queryParams.join('&')}`
      );
    }
  
    getById(id: number): Observable<ICompaniaModel> {
      return this.http.get<ICompaniaModel>(`${this.configUrl}/${id}`);
    }

    submit(model: ICompaniaModel) {
      return this.http.post<ActionResultModel>(`${this.configUrl}`, model);
    }
  
    update(model: ICompaniaModel) {
      return this.http.put<ActionResultModel>(
        `${this.configUrl}/${model.idCompania}`,
        model
      );
    }
  
    delete(id: number) {
      return this.http.delete<ActionResultModel>(`${this.configUrl}/${id}`);
    }

    setDefault(model: ICompaniaModel) {
      return this.http.post<ActionResultModel>(
        `${this.configUrl}/${model.idCompania}/setdefault`,
        model
      );
    }
}
